import { useEffect, useState } from "react";
import api from "@/lib/api";

export const WASH_CARS = [
  { id: "rangerover", label: "Range Rover" },
  { id: "gwagon", label: "Mercedes G-Wagon" },
  { id: "escalade", label: "Cadillac Escalade" },
  { id: "cayenne", label: "Porsche Cayenne" },
  { id: "sclass", label: "Mercedes S-Class" },
  { id: "bmw7", label: "BMW 7 Series" },
];

export const WASH_STYLES = [
  { id: "wipe", label: "Side wipe", desc: "Clean paint sweeps in from left to right with foam" },
  { id: "squeegee", label: "Squeegee drop", desc: "Clean paint pulls down from the roof like a squeegee" },
  { id: "spotlight", label: "Spotlight", desc: "A growing circle of clean paint spreads from the headlight" },
  { id: "diagonal", label: "Diagonal rinse", desc: "A slanted rinse line washes across the car" },
];

export const WASH_EFFECTS = [
  { id: "bubbles", label: "Soap bubbles", desc: "Foam and floating bubbles that pop along the wipe" },
  { id: "spray", label: "Water spray", desc: "Fast water droplets streaming off the rinse line" },
  { id: "sparkles", label: "Sparkles", desc: "Twinkling shine glints on the fresh paint" },
  { id: "none", label: "No effect", desc: "Just the clean glowing line, no particles" },
];

export const WASH_ENDINGS = [
  { id: "clean", label: "End on the clean car", desc: "Finishes on the shining car with your headline and buttons" },
  { id: "keys", label: "End with 'Keys back'", desc: "After the clean car, a hand presents the key in front of that same car" },
];

export const washImg = (name) => `/media/wash/${name}.webp`;

const BUILT_IN = WASH_CARS.map((c) => ({ ...c, dirty: washImg(`${c.id}-dirty`), clean: washImg(`${c.id}-clean`) }));
let cache = null;
const listeners = new Set();
export const loadWashCars = (force = false) => {
  if (!cache || force) {
    cache = api.get("/wash-cars").then((r) => [...BUILT_IN, ...r.data.items]).catch(() => BUILT_IN);
    cache.then((list) => listeners.forEach((fn) => fn(list)));
  }
  return cache;
};

export const useWashCars = () => {
  const [cars, setCars] = useState(BUILT_IN);
  useEffect(() => {
    listeners.add(setCars);
    loadWashCars().then(setCars);
    return () => listeners.delete(setCars);
  }, []);
  return cars;
};

// One rotation step per page load, so StrictMode / late custom-car loads don't skip cars
let rotateSeed = null;
export const pickCar = (val, cars) => {
  if (val !== "rotate") return cars.find((c) => c.id === val) || cars[0];
  if (rotateSeed === null) {
    rotateSeed = Number(localStorage.getItem("wash_rotate") || -1) + 1;
    localStorage.setItem("wash_rotate", String(rotateSeed));
  }
  return cars[rotateSeed % cars.length];
};
